import { Box } from "@chakra-ui/react";
import _ from "lodash";
import { useSelector } from "react-redux";
import FilterForm from "../../components/FilterForm";
import AgentServices from "../../components/branches/reports/AgentServices";
import Loader from "../../components/loader";
import { getReportDescription } from "../../store/helpers";

const AgentTicketsByService = ({ showFilterForm = true, reportIndex = 1 }) => {
  const { tickets, branches, organizationId, loading, reportRange, branchId } =
    useSelector((state) => state.defaultReducer);
  const ticketsClone = _.cloneDeep(tickets);
  const branchesClone = _.cloneDeep(branches);
  const orgBranches = branchesClone
    .filter(
      (branch) =>
        branch.organizationId === organizationId && Number(branch.reportStatus)
    )
    .filter((a) => !branchId.length || (branchId.length && a.id === branchId));

  //separate the data into branches
  const branchesMap = {};
  orgBranches.forEach((branch) => {
    branchesMap[branch.id] = [];
  });

  ticketsClone.forEach((data) => {
    const branchId = data.branchId;

    if (Array.isArray(branchesMap[branchId])) {
      branchesMap[branchId].push(data);
    }
  });

  const title = `${reportIndex}. Agent Tickets Per Service`;
  console.log(title);
  return (
    <Box>
      {showFilterForm ? <FilterForm /> : <></>}
      {loading ? (
        <>
          <Loader />
        </>
      ) : (
        <>
          {" "}
          {tickets.length ? (
            <>
              <h1>{title}</h1>
              <p>{getReportDescription(reportRange).AgentTicketsByService}</p>

              {Object.keys(branchesMap).map((branchId, index) => {
                return (
                  <AgentServices
                    branchData={branchesMap[branchId]}
                    branchId={branchId}
                    reportIndex={reportIndex}
                    branchIndex={index}
                  />
                );
              })}
            </>
          ) : (
            <Box mt={10}>
              <p>No data available in this search</p>
            </Box>
          )}
        </>
      )}
    </Box>
  );
};

export default AgentTicketsByService;
